import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ["reportId", "resultsContainer", "paginationContainer", "loadingIndicator", "errorMessage", "totalCount", "initialMessage", "noResultsMessage"]
  static values = {
    url: String,
    interval: { type: Number, default: 2000 },
    maxAttempts: { type: Number, default: 30 } // 60 secondes max
  }

  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasCommit = urlParams.has('commit');

    if (!this.hasReportIdTarget || !this.reportIdTarget.value || (!hasCommit && !this.reportIdTarget.value)) {
      this.hideLoading();
      return;
    }

    this.attempts = 0
    this.polling = false
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (this.polling) return

    this.polling = true
    this.showLoading()
    this.hideError()
    this.pollerId = setInterval(() => this.checkStatus(), this.intervalValue)
  }

  stopPolling() {
    if (this.pollerId) {
      clearInterval(this.pollerId)
      this.pollerId = null
    }
    this.polling = false
  }

  async checkStatus() {
    if (this.attempts >= this.maxAttemptsValue) {
      this.stopPolling()
      this.showError("The request is taking too long. Please try again later.")
      this.hideLoading()
      return
    }

    this.attempts++

    try {
      // Récupérer le numéro de page actuel depuis l'URL
      const urlParams = new URLSearchParams(window.location.search);
      const currentPage = urlParams.get('page') || 1;

      // Inclure le paramètre de page dans la requête AJAX
      const response = await fetch(`${this.urlValue}?report_id=${this.reportIdTarget.value}&page=${currentPage}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Erreur réseau")

      const data = await response.json()

      if (data.status === "ready") {
        this.handleReadyReport(data)
      } else if (data.status === "error") {
        const errorMessage = data.error_message || "An error occurred while processing your request."
        this.showError(errorMessage)
        this.stopPolling()
        this.hideLoading()
      }
    } catch (error) {
      console.error("Polling error:", error)
      this.showError("A communication error has occurred.")
      this.stopPolling()
      this.hideLoading()
    }
  }

  handlePaginationClicks() {
    if (!this.hasPaginationContainerTarget) return

    const paginationLinks = this.paginationContainerTarget.querySelectorAll('a')

    paginationLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault()

        const reportStatusUrl = new URL(link.href)
        const pageNumber = reportStatusUrl.searchParams.get('page')

        const currentUrl = new URL(window.location.href)
        const searchParams = currentUrl.searchParams

        if (pageNumber) {
          searchParams.set('page', pageNumber)
        } else {
          searchParams.delete('page')
        }

        if (searchParams.has('commit')) {
          const commitValue = searchParams.get('commit')
          searchParams.set('commit', commitValue)
        }

        window.location.href = currentUrl.toString()
      })
    })
  }

  handleReadyReport(data) {
    this.stopPolling()
    this.hideLoading()

    if (data.html && this.hasResultsContainerTarget) {
      this.resultsContainerTarget.innerHTML = data.html
    }

    if (data.pagination && this.hasPaginationContainerTarget) {
      this.paginationContainerTarget.innerHTML = data.pagination
      this.handlePaginationClicks()
    } else if (this.hasPaginationContainerTarget) {
      this.paginationContainerTarget.innerHTML = ''
    }

    const event = new CustomEvent('turbo:load')
    document.dispatchEvent(event)
  }

  showLoading() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.remove("hidden")
    }

    if (this.hasInitialMessageTarget) {
      this.initialMessageTarget.classList.add("hidden")
    }

    if (this.hasNoResultsMessageTarget) {
      this.noResultsMessageTarget.classList.add("hidden")
    }
  }

  hideLoading() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add("hidden")
    }
  }

  showError(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add("hidden")
    }
  }
}
